export default __webpack_public_path__ + "static/quarter-8cda982586240102537de2cc272a1b4e.png";